import { combineReducers } from "redux";

import alertReducer from "./alertReducer";
import apiReducer from "./apiReducer";
import authReducer from "./authReducer";
import cacheReducer from "./cacheReducer";
import modalReducer from "./modalReducer";
import notificationReducer from "./notificationReducer";
import overlayReducer from "./overlayReducer";
import pageStateReducer from "./pageStateReducer";
import trainingplanReducer from "./trainingplanReducer";
import tutorialReducer from "./tutorialReducer";

const allReducers = combineReducers({
    auth: authReducer,
    notification: notificationReducer,
    alert: alertReducer,
    api: apiReducer,
    cache: cacheReducer,
    tutorial: tutorialReducer,
    modal: modalReducer,
    overlay: overlayReducer,
    trainingPlan: trainingplanReducer,
    pageState: pageStateReducer,
});

export default allReducers;
